import React, { useState } from 'react';
import { FaQrcode } from 'react-icons/fa';

const DONATION_QR_IMAGE = `${process.env.PUBLIC_URL}/donation-qr.png`;

function DonationSupport({ children, compact = false, large = false }) {
  const [qrImageReady, setQrImageReady] = useState(true);
  const className = [
    'donation-support',
    compact ? 'donation-support-compact' : '',
    large ? 'donation-support-large' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={className}>
      <div className="donation-support-qr" aria-label="QR-код для пожертвования на счет">
        {qrImageReady ? (
          <img
            src={DONATION_QR_IMAGE}
            alt="QR-код для пожертвования на строительство храма"
            onError={() => setQrImageReady(false)}
          />
        ) : (
          <div className="donation-qr-placeholder" aria-hidden="true">
            <FaQrcode />
          </div>
        )}
      </div>

      <div className="donation-support-content">
        <p className="section-overline">Пожертвование</p>
        <h3>Поддержать строительство храма</h3>
        <p>
          Отсканируйте QR-код, чтобы сделать пожертвование на строительство храма.
        </p>
        {children}
      </div>
    </div>
  );
}

export default DonationSupport;
